module.exports = __webpack_public_path__ + "@/assets/img/banner-mp.4e1317dc.jpg";